// extracted by mini-css-extract-plugin
export default {"wrapper":"StretchLayout_wrapper__f2qRt","container":"StretchLayout_container__9M0s9","content":"StretchLayout_content__YeTzL"};